import { sessionStorageSet } from "@/utils/sessionStorage";

export type ThemeRootStore = {
  hasHeader: boolean;
  hasFooter: boolean;
  setLanguage: (language: string) => void;
  setTheme: (theme: string) => void;
};

export type ApplyThemeClassesOptions = {
  themeCandidate?: unknown;
  themes: string[];
  headLinkData: Record<string, unknown>;
  rootStore: ThemeRootStore;
  hasHeader: boolean;
  hasFooter: boolean;
};

export function applyLanguage(
  languageValue: unknown,
  rootStore: Pick<ThemeRootStore, "setLanguage">,
  locale?: { value: string },
): void {
  if (!languageValue) return;

  const language = String(languageValue);

  rootStore.setLanguage(language);

  if (locale) {
    locale.value = language;
  }

  sessionStorageSet("language", language);
}

export function applyThemeClasses(options: ApplyThemeClassesOptions): void {
  const bodyClassList = document.body?.classList;

  options.rootStore.hasHeader = options.hasHeader;

  if (options.hasHeader) {
    bodyClassList?.add("has-header");
  }

  options.rootStore.hasFooter = options.hasFooter;

  if (options.hasFooter) {
    bodyClassList?.add("has-footer");
  }

  options.themes.forEach((theme) => {
    bodyClassList?.remove(theme);
    bodyClassList?.remove(`theme-${theme}`);
  });

  Array.from(bodyClassList ?? []).forEach((className) => {
    if (className.startsWith("theme-")) {
      bodyClassList?.remove(className);
    }
  });

  const rawTheme = options.themeCandidate;
  const themeName = rawTheme == null ? "" : String(rawTheme);
  const themeKey = options.headLinkData[themeName] ? themeName : "covomo";

  if (!options.headLinkData[themeName]) {
    options.rootStore.setTheme("covomo");
  }

  bodyClassList?.add(`theme-${themeKey}`);
}
